// extracted by mini-css-extract-plugin
export default {"box-size-selection-label":"SelectBoxSize_box-size-selection-label__SnHal"};